import React from 'react';

import { Modal } from 'src/components/common';
import { DeclineVerificationRequestByVerifierModalContent } from 'src/components/verificationRequest';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import type { DeclineVerificationRequestByVerifierModalArgs } from './types';

export const DeclineVerificationRequestByVerifierModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } =
    useModal<DeclineVerificationRequestByVerifierModalArgs>(
      ModalId.DeclineVerificationRequestByVerifier,
    );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  if (isOpen && !args?.inboxItemId) {
    throw new Error('Missing inboxItemId in modal args');
  }

  return (
    <Modal
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      maxWidth={550}
    >
      <DeclineVerificationRequestByVerifierModalContent
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        inboxItemId={args?.inboxItemId || ''}
      />
    </Modal>
  );
};
